module.exports = __webpack_public_path__ + "static/media/thumbnail.35baad42.jpg";